/*
 * @Author: Json Chen
 * @Date: 2021-06-09 09:37:06
 * @LastEditTime: 2022-01-07 16:13:22
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/FloatingActionsBar/index.tsx
 */

import React from 'react';

import { store } from '@/src/store';

import ErrorProcessingHOC from '@/src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getFloatingActionsBar,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onFloatingActionsBarChange,
} from '../slice';

import { validateFloatingActionsBar } from '@/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/tools';
import { getInitialFloatingBar } from '@/src/request/salesChannel/content';
import FloatingActionsBarComponent from 'src/pages/SalesChannelContentEditor/Components/FloatingActionsBar';

import { convertFloatingBarDataToRedux } from '@/src/pages/SalesChannelContentEditor/Components/FloatingActionsBar/tools';
import { getI18nFromGeneral } from '@/src/tools/tools';

const FloatingActionsBar = (props) => {
  return (
    <FloatingActionsBarComponent
      {...props}
      onFloatingActionsBarChange={onFloatingActionsBarChange}
    />
  );
};

export default ErrorProcessingHOC(FloatingActionsBar, {
  getCollapseOpenStatus,
  onCollapseOpen,
  headerProps: {
    dotsFunction: [
      {
        onClick: (params, data) => {
          getInitialFloatingBar().then((response) => {
            store.dispatch(
              onFloatingActionsBarChange(
                convertFloatingBarDataToRedux(response),
              ),
            );
          });
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
  },
  id: EnumCollapseId.floatingBar,
  getContent: getFloatingActionsBar,
  title: getI18nFromGeneral('general.hOCTitle.floatingActionsBar'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, _p) => {
    const { isPrimary } = _p;
    return validateFloatingActionsBar(x, isPrimary);
  },
  getSubmitStamp,
});
